import styled from 'styled-components';
import { StyledScatterPlotProps } from './types';
import { ChartContainer } from '../ChartContainer';
import { Theme } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledScatterPlot = styled(ChartContainer)<StyledScatterPlotProps>``;

export const StyledScatterPlotEmptyText = styled.div<{
  $maxWidth: number;
  $textSize: number;
  $theme: Theme;
}>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: none;

  > * {
    max-width: ${({ $maxWidth }) => $maxWidth}px;
  }

  > span {
    font-family: var(--redsift-typography-font-family-poppins);
    color: ${({ $theme }) => `var(--redsift-color-${$theme}-components-text-primary)`};
    font-size: ${({ $textSize }) => $textSize}px;
    line-height: ${({ $textSize }) => $textSize}px;
  }
`;
